// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/LaudoPublico_GenerateLinkResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /laudo_links/generate_link
 *
 * Returns the PERSISTENT public token (reused on every resend) plus the
 * client's name and phone. Mirrors ClientesPreencher_GenerateLinkResponse.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface LaudoPublico_GenerateLinkResponseDados {
token?: string
link_url?: string
tipo?: string
cliente_nome?: string
cliente_telefone?: string
}

export type LaudoPublico_GenerateLinkResponse = ApiResponse<LaudoPublico_GenerateLinkResponseDados>;

registerResponseContract('LaudoPublico_GenerateLinkResponse', {
  token:            { type: 'string',  required: false },
  link_url:         { type: 'string',  required: false },
  tipo:             { type: 'string',  required: false },
  cliente_nome:     { type: 'string',  required: false },
  cliente_telefone: { type: 'string',  required: false },
})
